export enum BeneficiaryPendencyStatusTranslatedEnum {
	ACTIVE = 'ativos',
	EXCLUSION = 'exclusoes',
	INACTIVE = 'inativos',
	INCLUSION = 'inclusoes',
	SCHEDULED_TRANSFERS = 'transferencias_programadas',
}
